import { lazy } from "react";


import BookingDetails from "pages/BookingDetails";
import SearchForm from "pages/SearchForm";
import PaymentForm from "pages/PaymentForm";



const Bookings = lazy(() => import("pages/Bookings"));
const Services = lazy(() => import("pages/Services"));
const ServiceDetail = lazy(() => import("pages/Services/ServiceDetail"));
const NotAuthorize = lazy(() => import("pages/NotAuthorize"));

export { default } from "./AppRoutes";

export interface IRoute {
  path: string;
  element: JSX.Element;
}

export const public_routes: IRoute[] = [
  { path: "/", element: <Services /> },
  { path: "/service/:id", element: <ServiceDetail /> },
  { path: "/not-authorize", element: <NotAuthorize /> },
];

export const private_routes: IRoute[] = [
  { path: "/search-form", element: <SearchForm /> },
  { path: "/payment-form", element: <PaymentForm /> },
  // { path: "/bookings", element: <Bookings /> },
  { path: "/booking/:id", element: <BookingDetails /> },
];
